<script lang="ts" setup>
import { usePolisAlertsGetAlertvariabelen } from '@services/alerts-public/orval-api/polis-alerts/polis-alerts';
import { VButton } from '@shared/component/VButton';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import VButtonGroup from '@shared/component/VButtonGroup/VButtonGroup.vue';
import { capitalize } from '@tools/helpers';
import { computed } from 'vue';

const emit = defineEmits<{ selected: [value: string] }>();

const { data: alertVariabelen, isPending } = usePolisAlertsGetAlertvariabelen({
  query: {
    select: (data) => data.result,
  },
});

const alertsLabelValuePairs = computed(
  () =>
    alertVariabelen.value?.map((r) => ({
      label: String(r.userFriendlyName),
      value: String(r.displayName),
    })) ?? [],
);
</script>

<template>
  <FieldRowV2 label="Variabelen" :label-size="1" v-if="!isPending">
    <VButtonGroup attached>
      <VButton
        v-for="varButton in alertsLabelValuePairs"
        :key="varButton.label"
        @click.prevent="emit('selected', varButton.label)"
        inverted
        class="text-xs"
      >
        {{ capitalize(varButton.value) }}
      </VButton>
    </VButtonGroup>
  </FieldRowV2>
</template>
